<template>
  <div class="overflow-menu">
    <form-button
      class="overflow-menu__icon btn-icon--sm font--18px text--gray"
      icon="more_vert"
      @click="toggle"
      v-click-outside="toggleOff"
    ></form-button>
    <ul
      class="overflow-menu--container"
      :class="isSelected"
    >
      <slot></slot>
    </ul>
  </div>
</template>

<script>

import toggle from '@/component/js/toggle'

export default {
  mixins: [toggle],
  components: {
    FormButton: () => import('@/component/ui2/button/FormButton')
  }
}
</script>
